module.exports = __webpack_public_path__ + "img/unstarted.6ab99a5d.svg";